/** @jsx jsx */
import FullScreenLoader from 'components/FullScreenLoader'
import {navigate} from 'gatsby'
import useUser from 'hooks/useUser'
import React, {useEffect} from 'react'
import {jsx} from 'theme-ui'

export default function redirectIfAnonymous<P extends object>(
  Component: React.FC<P>,
): React.FC<P> {
  return function RedirectIfAnonymous(props) {
    const {loading, isAuthenticated} = useUser()
    useEffect(() => {
      if (!loading && !isAuthenticated) {
        navigate('/login/')
      }
    }, [loading, isAuthenticated])
    if (loading) {
      return <FullScreenLoader />
    }

    return <Component {...props} />
  }
}
